import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/Navbar.css";
import assets from "../assets/images";
import { FaBars, FaTimes } from "react-icons/fa"; // Import icons

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`pb-navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="pb-logo">
  <a href="https://priyanthabandara.lk" rel="noopener noreferrer">
    <img src={assets.main_logo} alt="PB Photography Logo" />
  </a>
</div>


      {/* Hamburger Menu Button */}
      <div className="pb-menu-icon" onClick={() => setIsMenuOpen(!isMenuOpen)}>
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Navbar Links */}
      <ul className={`pb-nav-links ${isMenuOpen ? "active" : ""}`}>
        <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
        <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>About Us</Link></li>
        <li><Link to="/packages" onClick={() => setIsMenuOpen(false)}>Packages</Link></li>
        <li><Link to="/gallery" onClick={() => setIsMenuOpen(false)}>Gallery</Link></li>
        <li><Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact Us</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
